import React, { useState, useEffect, useContext } from "react";
import { Card, CardContent, CardHeader, Button } from "@mui/material";
import { Calendar } from "lucide-react";
import { AuthContext } from "../../../../shared/context/auth-context";
import { ClinicaContext } from "../../../../shared/context/clinica-context";
import { useHttpClient } from "../../../../shared/hooks/http-hook";
import ModalListaAgendamentosProvisorio from "../modalListaAgendamentosProvisorio/ModalListaAgendamentosProvisorio";

import { contarLembretesPendentes } from "../../../../shared/util/agendamentoProvisorioHelpers";
import { Phone, Clock } from "lucide-react";

import "./CardAgendamentosProvisorio.scss";

function CardAgendamentosProvisorio({ refreshTrigger }) {
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);
  const { sendRequest } = useHttpClient();
  const [agendamentos, setAgendamentos] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (clinica?.clinica?._id) {
      fetchAgendamentos();
    }
  }, [clinica?.clinica?._id]);

  useEffect(() => {
    if (refreshTrigger > 0) {
      fetchAgendamentos();
    }
  }, [refreshTrigger]);

  const fetchAgendamentos = async () => {
    try {
      const params = new URLSearchParams();
      params.append("status", "PENDENTE");

      const responseData = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/agendamentosprovisorio/${
          clinica.clinica._id
        }?${params.toString()}`,
        "GET",
        null,
        {
          Authorization: "Bearer " + auth.token,
        }
      );

      setAgendamentos(responseData.agendamentos || []);
    } catch (err) {
      console.error("Erro ao buscar agendamentos:", err);
    }
  };

  const totalPendentes = agendamentos.length;

  return (
    <>
      <Card className="card-agendamentos-provisorio-compact">
        <CardHeader
          title="Agendamentos Provisórios"
          avatar={<Calendar color="#00897b" size={24} />}
        />
        <CardContent className="card-content-compact">
          <div className="counter-section">
            <div className="counter-number">{totalPendentes}</div>
            <div className="counter-label">
              {totalPendentes === 0
                ? "agendamentos pendentes"
                : totalPendentes === 1
                ? "agendamento pendente"
                : "agendamentos pendentes"}
            </div>
          </div>

          {(() => {
            const { urgentes, hoje } = contarLembretesPendentes(agendamentos);
            if (urgentes > 0 || hoje > 0) {
              return (
                <div className="lembretes-info">
                  {urgentes > 0 && (
                    <div className="lembrete-linha urgente">
                      <Phone size={16} />
                      <span>
                        {urgentes}{" "}
                        {urgentes === 1
                          ? "chamada urgente"
                          : "chamadas urgentes"}
                      </span>
                    </div>
                  )}
                  {hoje > 0 && (
                    <div className="lembrete-linha hoje">
                      <Clock size={16} />
                      <span>{hoje} para hoje</span>
                    </div>
                  )}
                </div>
              );
            }
            return null;
          })()}

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={() => setModalOpen(true)}
            className="btn-ver-todos"
            disabled={totalPendentes === 0}
          >
            Ver Todos
          </Button>
        </CardContent>
      </Card>

      {modalOpen && (
        <ModalListaAgendamentosProvisorio
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          onUpdate={fetchAgendamentos}
        />
      )}
    </>
  );
}

export default CardAgendamentosProvisorio;
